import { useState, useEffect, useRef } from 'react';
import { getCurrentLang } from '../components/LangSelector';

const cache = new Map();

export default function useTranslation(jobId, originalTitle, originalDescription) {
  const [title, setTitle] = useState(originalTitle);
  const [description, setDescription] = useState(originalDescription);
  const mounted = useRef(true);

  useEffect(() => {
    mounted.current = true;
    return () => { mounted.current = false; };
  }, []);

  const doTranslate = async () => {
    const lang = getCurrentLang();
    if (lang === 'ro') {
      if (mounted.current) {
        setTitle(originalTitle);
        setDescription(originalDescription);
      }
      return;
    }

    const key = `${jobId}_${lang}`;
    if (cache.has(key)) {
      const { title: t, description: d } = cache.get(key);
      if (mounted.current) { setTitle(t || originalTitle); setDescription(d || originalDescription); }
      return;
    }

    try {
      const form = new FormData();
      form.append('job_id', jobId);
      form.append('lang', lang);

      const res = await fetch('/api/translate_job.php', { method: 'POST', body: form });
      const data = await res.json();

      if (data.title || data.description) {
        cache.set(key, { title: data.title, description: data.description });
        if (mounted.current) {
          setTitle(data.title || originalTitle);
          setDescription(data.description || originalDescription);
        }
      }
    } catch {
      // Оригинал остаётся
    }
  };

  // При изменении языка
  useEffect(() => {
    doTranslate();
  }, [jobId]);

  useEffect(() => {
    const handler = () => {
      // При смене языка очищаем кеш и переводим заново
      cache.clear();
      doTranslate();
    };
    window.addEventListener('app:langChange', handler);
    return () => window.removeEventListener('app:langChange', handler);
  }, []);

  return { title, description };
}
